import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  text1: string;
  text2: string;
  text3: string;
  text4: string;
  listtext1: string;
  listtext2: string;
  listtext3: string;
  title: string;
  paragraph1: string;
  paragraph2: string;
  paragraph3: string;
  list1: string;
  list2: string;
  list3: string;
}

export const PolicyEngagementAndResourcesContent: RouteInfo[] = [
  {
    text1:
      "CHCC's Supplier Development Program is designed to expand the number of Hispanic and diverse businesses certified and competitive in securing corporate and government contract opportunities. ",
    text2:
      "CHCC's Supplier Development program prepares businesses to understand requirements and prepare a business to pursue, win and perform contracts with corporations, federal agencies, state and local governments, and prime contractors.",
    text3:
      'The CHCC advances business opportunities for diverse business enterprises and connects them to corporate, government, and prime contractor opportunities.',
    text4: 'To achieve our mission, the CHCC:',
    listtext1:
      'Advocates to support and facilitate the integration of diverse businesses into corporate, public-sector, and prime contractor supply chains.',
    listtext2:
      'Build diverse business capacity, capabilities, and competitiveness through our programs and other educational offerings.',
    listtext3:
      'Facilitate partnerships to meet the needs of our corporate members and their procurement and supplier diversity needs.',
    title: 'CHCC Supplier Diversity Statement',
    paragraph1:
      'The CHCC advocates and encourages corporations, government, and prime contractors to make supplier diversity and development an essential part of their focus on Diversity, Equality, and Inclusion.',
    paragraph2:
      "The CHCC encourages the engagement of minorities, women, LGBTQIA+, veterans, and disabled small businesses integrated into a company's strategic sourcing and procurement processes to generate efficiency, innovation, and increased opportunities for diverse suppliers. The CHCC is committed to support partnerships in the diverse business community, developing these businesses for growth, and engaging with community organizations that share our commitment.",
    paragraph3:
      "The CHCC monitors supplier diversity and development practices for effectiveness through performance goals and ensures that all management levels emphasize the company's commitment; together, the CHCC, its partners, and diverse suppliers can contribute to our communities' long-term economic sustainability.",
    list1: 'Elevate',
    list2: 'Certifications',
    list3: 'Supplier Diversity Programs and Information',
  },
];

@Component({
    selector: 'app-supplier-diversity',
    templateUrl: './supplier-diversity.component.html',
    styleUrls: ['./supplier-diversity.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupplierDiversityComponent implements OnInit {
  mainTitle = 'Supplier Diversity & Procurement';
  texts: any = [];

  constructor() {}

  ngOnInit(): void {
    this.texts = PolicyEngagementAndResourcesContent.filter((text) => text);
  }
}
